import { combineReducers } from 'redux';

import {
    SAVE_SITE_SUCCESS,
    PROFILE_SITES_REQUEST,
    PROFILE_SITES_SUCCESS,
    PROFILE_SITES_FAILURE,
    CONFIG_DOMAIN_FAILURE,
    CONFIG_DOMAIN_SUCCESS,
    CONFIG_DOMAIN_REQUEST,
    DELETE_SITE_SUCCESS,
    DELETE_SITE_FAILURE,
    DELETE_SITE_REQUEST,
    DUPLICATE_SITE_SUCCESS,
    SAVE_SITE_FAILURE,
    SET_SITE_SAVED_STATUS,
    FETCH_SITE_SUCCESS,
    SITE_CLEAR_MESSAGE,
    EXPORT_FILES_REQUEST,
    EXPORT_FILES_SUCCESS,
    EXPORT_FILES_FAILURE,
} from '../actionTypes';

import { pageTypes } from '../actionTypes';
const {
    REMOVE_PAGE_SUCCESS,
    FETCH_PAGE_SUCCESS,
    CREATE_PAGE_REQUEST,
    CREATE_PAGE_SUCCESS,
    CREATE_PAGE_FAILURE,
} = pageTypes;

function byId(state = {}, action) {
    if (!action) return state;

    switch (action.type) {
        case SAVE_SITE_SUCCESS: {
            const { site } = action.payload;
            return { ...state, [site.id]: { ...site } };
        }

        // just to update props for the site
        case SAVE_SITE_FAILURE: {
            const failedSite = state[action.payload.id];
            return { ...state, [action.payload.id]: { ...failedSite } };
        }

        case PROFILE_SITES_SUCCESS: {
            const nextState = {};
            action.payload.forEach((site) => (nextState[site.id] = site));
            return nextState;
        }
        case CONFIG_DOMAIN_SUCCESS: {
            const {
                site: { id, ...newData },
            } = action.payload;
            const oldData = state[id];
            return { ...state, [id]: { ...oldData, ...newData } };
        }
        case DELETE_SITE_SUCCESS: {
            const nextState = { ...state };
            delete nextState[action.siteId];
            return nextState;
        }
        case DUPLICATE_SITE_SUCCESS: {
            const { site } = action.payload;
            return { ...state, [site.id]: site };
        }
        case FETCH_SITE_SUCCESS: {
            const {
                site: { id, ...newData },
            } = action.payload;
            const oldData = state[id];
            return { ...state, [id]: { ...oldData, ...newData } };
        }

        case REMOVE_PAGE_SUCCESS: {
            const { pageId, siteId } = action.payload;
            const site = state[siteId];
            const pages = site.pages.filter((page) => page.id !== pageId);
            return {
                ...state,
                [siteId]: { ...site, pages },
            };
        }

        case CREATE_PAGE_SUCCESS: {
            const { page, siteId, isNew } = action.payload;
            const site = state[siteId];
            const pages = [...site.pages];
            isNew
                ? pages.push(page)
                : pages.splice(
                      pages.findIndex((item) => item.id === page.id),
                      1,
                      page
                  );

            return {
                ...state,
                [siteId]: { ...site, pages },
            };
        }
        default:
            return state;
    }
}

function pagesById(state = {}, action) {
    if (!action) return state;

    switch (action.type) {
        case FETCH_SITE_SUCCESS: {
            const nextState = { ...state };
            action.payload.site.pages.forEach((page) => {
                const existingPage = nextState[page.id];
                nextState[page.id] = { ...existingPage, ...page };
            });
            return nextState;
        }

        case FETCH_PAGE_SUCCESS: {
            const { id, data } = action.payload;
            const page = { ...state[id], id, data };
            return { ...state, [id]: page };
        }

        case CREATE_PAGE_SUCCESS: {
            const { page } = action.payload;
            const nextPage = { ...state[page.id], ...page };
            return { ...state, [page.id]: nextPage };
        }

        default:
            return state;
    }
}

// Must refactor and should return array of ids
function allSites(state = [], action) {
    if (!action) return state;

    switch (action.type) {
        case PROFILE_SITES_SUCCESS:
            return action.payload.map((site) => site.id);

        case DELETE_SITE_SUCCESS:
            return state.filter((id) => id !== action.siteId);

        case DUPLICATE_SITE_SUCCESS: {
            const { siteId, payload } = action;
            const index = state.findIndex((id) => id === siteId);
            const nextState = [...state];
            nextState.splice(index + 1, 0, payload.site.id);
            return nextState;
        }

        default:
            return state;
    }
}

function isLoading(state = false, action) {
    if (!action) return state;
    switch (action.type) {
        case CREATE_PAGE_REQUEST:
        case PROFILE_SITES_REQUEST:
            return true;
        case CREATE_PAGE_SUCCESS:
        case CREATE_PAGE_FAILURE:
        case PROFILE_SITES_SUCCESS:
        case PROFILE_SITES_FAILURE:
            return false;
        default:
            return state;
    }
}

function isLoadingExport(state = false, action) {
    if (!action) return state;
    switch (action.type) {
        case EXPORT_FILES_REQUEST:
            return true;
        case EXPORT_FILES_SUCCESS:
        case EXPORT_FILES_FAILURE:
            return false;
        default:
            return state;
    }
}

function errorMessage(state = '', action) {
    if (!action) return state;

    switch (action.type) {
        case SAVE_SITE_FAILURE:
            return action.payload.message;

        case CONFIG_DOMAIN_FAILURE:
        case DELETE_SITE_FAILURE:
            return action.errorMessage;

        case SITE_CLEAR_MESSAGE:
        case DELETE_SITE_REQUEST:
        case CONFIG_DOMAIN_REQUEST:
            return '';

        default:
            return state;
    }
}

function successMessage(state = '', action) {
    if (!action) return state;

    switch (action.type) {
        case SAVE_SITE_SUCCESS:
            return action.payload.message;

        case CONFIG_DOMAIN_SUCCESS:
            return action.payload.message;

        case SITE_CLEAR_MESSAGE:
        case CONFIG_DOMAIN_FAILURE:
        case CONFIG_DOMAIN_REQUEST:
            return '';

        default:
            return state;
    }
}

function isSavedSite(state = true, action) {
    if (!action) return state;

    switch (action.type) {
        case SAVE_SITE_SUCCESS:
            return true;
        case SAVE_SITE_FAILURE:
            return false;
        case SET_SITE_SAVED_STATUS:
            return action.status;

        default:
            return state;
    }
}

export default combineReducers({
    byId,
    allSites,
    pagesById,
    isLoading,
    isSavedSite,
    errorMessage,
    successMessage,
    isLoadingExport,
});

export const getSite = (state, id) => state.byId[id];
export const getPage = (pageId) => (state) => state.pagesById[pageId];
export const getHomePage = (siteId) => (state) => {
    const site = state.byId[siteId];
    const pageId = site?.pages?.find((page) => page.type === 'INDEX')?.id;
    return pageId && getPage(pageId)(state);
};
export const getPagesBySiteId = (siteId) => (state) =>
    state.byId[siteId]?.pages;
export const getIsLoading = (state) => state.isLoading;
export const getIsLoadingExport = (state) => state.isLoadingExport;
export const getIsSavedSite = (state) => state.isSavedSite;
export const getSiteMutationError = (state) => state.errorMessage;
export const getSiteMutationSuccess = (state) => state.successMessage;
export const getSites = (state) =>
    state.allSites.map((siteId) => getSite(state, siteId));
